export default __webpack_public_path__ + "static/media/arrow-down.02158906.svg";